import { createRequestActionTypes } from '../../helpers'

export const FETCH_TUTORIAL_LIST = createRequestActionTypes(
  'TUTORIAL_LIST',
  'FETCH'
)
